<template>
    <v-layout>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3 v-if="ready">
            <h2>This app is no longer in use, please contact fleetsupport@motia.com for details of how to access the new Nexus app</h2>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      ready: false
    }
  },
  created () {
    setTimeout(() => {
      this.ready = true
    }, 1000)
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user: {
      handler (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      },
      immediate: true
    }
  },
  methods: {
    onSignin () {
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>



// WEBPACK FOOTER //
// SignIn.vue?78dd4011